
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M12 16.5c-2.37 0-4.289-1.835-4.465-4.16L4.256 9.807c-.43.54-.827 1.112-1.147 1.737a1.01 1.01 0 000 .912C4.804 15.763 8.159 18 12 18a9.71 9.71 0 002.434-.327l-1.621-1.255c-.268.052-.54.08-.813.082zm9.807 1.816l-3.455-2.67a10.351 10.351 0 002.54-3.19 1.011 1.011 0 000-.912C19.196 8.237 15.841 6 12 6a9.63 9.63 0 00-4.604 1.178L3.421 4.105a.5.5 0 00-.702.088l-.614.79a.5.5 0 00.088.701l18.386 14.21a.5.5 0 00.702-.087l.614-.79a.5.5 0 00-.088-.701zm-5.741-4.438l-1.228-.95a2.961 2.961 0 00-3.629-3.81c.189.256.29.565.291.882-.005.105-.02.21-.048.312l-2.3-1.777A4.447 4.447 0 0112 7.5a4.497 4.497 0 014.5 4.5c0 .676-.165 1.306-.434 1.878z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 4)","d":"M0 0h20v16H0z"}})])])])
          )
        }
      }
    